// angular
//     .module("HeroPRO")
//     .controller("GetSignaturesModalController", getSignaturesModalController);

import _ from 'lodash';
import './getSignatures.scss';

/* @ngInject */
export default function getSignaturesModalController($uibModalInstance, $scope, EDocumentsFactory, $stateParams, $q, $window, activeTab, HPConfig, HPStateMachineConfig, FRInformationFactory, AccountsFactory, FRDocumentsFactory, UserData, PermissionsFactory) {
    const vm = this;
    vm.stateMachineData = {};
    vm.recipients = {};
    vm.pendingSignatures = false;
    vm.signNow = signNow;
    vm.sendEmail = sendEmail;
    vm.sendRepresentativeEmail = sendRepresentativeEmail;
    vm.setActiveTab = setActiveTab;
    vm.sendEmailButtons = [];
    vm.sendRepresentativeEmailButtonStatus = 0;
    vm.CCDocument = null;
    vm.ACADocument = null;
    vm.userProfile = {};
    vm.contractorUserId = '';
    vm.OrganizationId = '';

    FRDocumentsFactory.getFundingRequestDocumentsPromise().then(() => {
        vm.stateMachineData = FRInformationFactory.getStateMachineData();
        vm.CCDocument = FRDocumentsFactory.getCCDocument();
        vm.ACADocument = FRDocumentsFactory.getACADocument();
        init();
    });

    function init() {
        getCurrentLocation();
        getContractorUser();

        if (vm.CCDocument !== null) {
            if (vm.stateMachineData.CompletionCertificateStateId !== HPStateMachineConfig.CC.Completion_Cert_Generated &&
                vm.stateMachineData.CompletionCertificateStateId !== HPStateMachineConfig.CC.Product_Details_Confirmed &&
                vm.stateMachineData.CompletionCertificateStateId !== HPStateMachineConfig.CC.Payment_Instructions_Confirmed) {
                const CCRecipients = (vm.CCDocument.ESignDocumentEnvelope) ? vm.CCDocument.ESignDocumentEnvelope.EDocumentRecipients : [];
                for (let i = 0; i < CCRecipients.length; i++) {
                    vm.recipients[CCRecipients[i].OrdinalInRole] = {
                        FirstName: CCRecipients[i].FirstName,
                        LastName: CCRecipients[i].LastName,
                        Email: CCRecipients[i].Email,
                        OrdinalInRole: CCRecipients[i].OrdinalInRole,
                        AllDocsSigned: CCRecipients[i].EDocumentRecipientStatus === 5 || vm.CCDocument.status.CCUploaded,
                        CC: CCRecipients[i],
                        ACA: null
                    };
                }
            }
        }

        if (vm.ACADocument !== null) {
            const ACARecipients = (vm.ACADocument.ESignDocumentEnvelope) ? vm.ACADocument.ESignDocumentEnvelope.EDocumentRecipients : [];
            for (let j = 0; j < ACARecipients.length; j++) {
                if (vm.recipients[ACARecipients[j].OrdinalInRole] !== undefined) {
                    vm.recipients[ACARecipients[j].OrdinalInRole].ACA = ACARecipients[j];
                    vm.recipients[ACARecipients[j].OrdinalInRole].AllDocsSigned = vm.recipients[ACARecipients[j].OrdinalInRole].AllDocsSigned && ACARecipients[j].EDocumentRecipientStatus === 5;
                } else {
                    vm.recipients[ACARecipients[j].OrdinalInRole] = {
                        FirstName: ACARecipients[j].FirstName,
                        LastName: ACARecipients[j].LastName,
                        Email: ACARecipients[j].Email,
                        OrdinalInRole: ACARecipients[j].OrdinalInRole,
                        AllDocsSigned: ACARecipients[j].EDocumentRecipientStatus === 5,
                        ACA: ACARecipients[j],
                        CC: null
                    };
                }
            }
        }

        for (let k = 0; k < Object.keys(vm.recipients).length; k++) {
            vm.sendEmailButtons.push({ status: 0 });
        }

        setActiveTab(activeTab);

        vm.pendingSignatures = _.some(vm.recipients, recipient => !recipient.AllDocsSigned);
    }

    vm.closeModal = function () {
        $uibModalInstance.close();
    };

    function setActiveTab(newActiveTab) {
        vm.activeTab = newActiveTab;
    }

    function signNow(recipient, documentType) {
        if (documentType === 'AssesmentContractAddendum') {
            $window.open(`${HPConfig.idVerifyLink}#app/${recipient.ACA.EDocumentRecipientID}/${vm.ACADocument.ESignDocumentEnvelope.EnvelopeID}`);
        } else if (documentType === 'CompletionCertificate') {
            $window.open(`${HPConfig.idVerifyLink}#app/${recipient.CC.EDocumentRecipientID}/${vm.CCDocument.ESignDocumentEnvelope.EnvelopeID}`);
        }
    }
    function sendEmail(recipient, recipientIndex) {
    // EDocumentRecipientStatusDate
        if (recipient.Email && recipient.Email.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i)) {
            if (vm.sendEmailButtons[recipientIndex].status === 0) {
                vm.sendEmailButtons[recipientIndex].status = 1;

                const fundingRequestId = $stateParams.appId;
                const loanId = FRDocumentsFactory.getESignDocuments()[0].ESignDocumentEnvelope.LoanId;

                let emailPromise1;
                let emailPromise2;

                if (recipient.ACA && recipient.ACA.EDocumentRecipientStatus !== 5) {
                    emailPromise1 = EDocumentsFactory.emailDocusignLink(fundingRequestId, recipient.ACA.EDocumentRecipientID, 'AssesmentContractAddendum', recipient.Email, recipient.OrdinalInRole, loanId);
                }
                if (recipient.CC && recipient.CC.EDocumentRecipientStatus !== 5) {
                    emailPromise2 = EDocumentsFactory.emailDocusignLink(fundingRequestId, recipient.CC.EDocumentRecipientID, 'CompletionCertificate', recipient.Email, recipient.OrdinalInRole, loanId);
                }

                $q.all([emailPromise1, emailPromise2]).then(() => {
                    vm.sendEmailButtons[recipientIndex].status = 2;
                });
            }
        } else {
            $window.alert('Invalid Email');
        }
    }

    function sendRepresentativeEmail(representativeEmail) {
        if (representativeEmail && representativeEmail.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i)) {
            if (vm.sendRepresentativeEmailButtonStatus === 0) {
                vm.sendRepresentativeEmailButtonStatus = 1;

                EDocumentsFactory.emailInstaller($stateParams.appId, representativeEmail).then(() => {
                    vm.sendRepresentativeEmailButtonStatus = 2;
                });
            }
        } else {
            $window.alert('Invalid Email');
        }
    }

    function getCurrentLocation() {
        UserData.getCurrentLocation().then((data) => {
            vm.OrganizationId = data.OrganizationId;
        });
    }

    function getContractorUser() {
        AccountsFactory.getContractorUser($stateParams.accountId).then((response) => {
            if (response.data.Data !== undefined || response.data.Data !== null) {
                vm.userProfile = response.data.Data;
                vm.contractorUserId = vm.userProfile.ContractorUserId;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/appDetail/getClosingSignaturesModal/getSignaturesModalController.js